import { BookPlusMultipleIcon } from './BookPlusMultipleIcon';

/**
 * author: Perth Totty
 * id 9A754066-7A7A-4362-9530-C8500B178DED
 * name book-plus-multiple
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-plus-multiple.svg
 * tags
 */
export const BooksAddIcon = BookPlusMultipleIcon;
export default BooksAddIcon